import { SelectOption } from "../../common/types"
import HttpClient from "../helpers/HttpClient"
import PaymentTerm, { PaymentTermDto } from "./PaymentTerm"

class PaymentTermService {
    static httpClient = new HttpClient<PaymentTerm, PaymentTermDto>(PaymentTerm)

    static async get() {
        const res = await this.httpClient.get("/payment-terms")

        if (Array.isArray(res)) {
            return res
        }

        return res
    }

    static async getLabelsAsSelectOptions(): Promise<SelectOption<string>[]> {
        const res = await this.get()

        if (Array.isArray(res)) {
            return res.map(label => ({
                value: label.getId(),
                label: label.getName(),
            }))
        }

        return []
    }
}

export default PaymentTermService


// WEBPACK FOOTER //
// ./src/state/payment-term/PaymentTermService.ts